import React from 'react';
import { Grid } from '@material-ui/core';

import { ServiceFeatures } from './ServiceFeatures';
import { ServiceList } from './ServiceList';
import { ContainerSection } from '../../../shared/components/ContainerSection';

export const Services = () => (
  <ContainerSection position="top" anchor="servizi" title="Servizi">
    <Grid container spacing={10}>
      <Grid item xs={12} md={6}>
        <ServiceList />
      </Grid>
      <Grid item xs={12} md={6}>
        <ServiceFeatures />
      </Grid>
    </Grid>
  </ContainerSection>
);
